import * as React from 'react'
import { Auth } from 'src/components/Auth'
import { PageContent } from 'src/components/layout/PageContent'
import {
  PageHeader,
  SubTitle,
  TitleLink
} from 'src/components/layout/PageHeader'
import { Paper } from 'src/components/Paper'
import { Link } from 'gatsby'
import { SEO } from 'src/components/Seo'

const Signup = () => {
  return (
    <>
      <SEO title={"Signup"} />
      <PageContent>
        <PageHeader title={'Welcome to Boxtronik'}>
          <SubTitle>
            Allready have an account?
            <br />
            <TitleLink to={'/login'}>Login!</TitleLink>
          </SubTitle>
        </PageHeader>
        <Paper>
          <Auth {...{ context: 'signup' }} />
        </Paper>
      </PageContent>
    </>
  )
  // const [login, { data }] = useMutation(gql`
  //   mutation LOGIN($email: String!, $password: String!) @client {
  //     login(email: $email, password: $password) @client
  //   }
  // `)
  // return (
  //   <div>
  //     <input type="email" placeholder="email" />
  //     <input type="password" placeholder="password" />
  //     <button
  //       {...{
  //         onClick: (e) =>
  //           login({ email: 'text@jfa.gmbh', password: '12345678' }).then(
  //             console.log
  //           )
  //       }}
  //     >
  //       Login
  //     </button>
  //   </div>
  // )
}

export default Signup
